import { ICommitOrderInput } from '../types';

export const mapCardType = (options: ICommitOrderInput) => options.creditType;
